import {
  Box,
  Table,
  Text,
  Tbody,
  Td,
  Th,
  Thead,
  Tr,
  BoxProps,
  Icon,
} from '@chakra-ui/react';
import { useMemo } from 'react';
import { RiEyeLine } from 'react-icons/ri';
import { LinkButton } from '../../../../../../../components/LinkButton';
import { Pagination } from '../../../../../../../components/Pagination';
import { TableFilters } from '../../../../../../../components/TableFilters';
import { IVentureListItem } from '../../../../../../../services/Ventures/ListVenturesService';

export interface IVenture extends IVentureListItem {
  formattedDate: string;
}

interface IVentureTableProps extends BoxProps {
  ventures: IVenture[];
  currentPage?: number;
  filterBy?: string;
  onChangeFilterBy?: (value: string) => void;
  onFilter?: (value: string) => void;
  onOrder?: (order: 'ASC' | 'DESC') => void;
  onPageChange?: (page: number) => void;
  onSort?: (sort: 'cnpj' | 'name' | 'phone' | 'email' | 'createdAt') => void;
  order?: 'ASC' | 'DESC';
  sortBy?: string;
  totalPages?: number;
}

export const VentureTable = ({
  ventures,
  currentPage,
  filterBy,
  onChangeFilterBy,
  onFilter,
  onOrder,
  onPageChange,
  onSort,
  order,
  sortBy,
  totalPages,
  ...rest
}: IVentureTableProps): JSX.Element => {
  const filterByOptions = useMemo(
    () => [
      {
        label: 'Name',
        value: 'name',
      },
      {
        label: 'E-mail',
        value: 'email',
      },
      {
        label: 'Phone',
        value: 'phone',
      },
      {
        label: 'CNPJ',
        value: 'cnpj',
      },
    ],
    [],
  );

  const sortByOptions = useMemo(
    () => [
      {
        label: 'Name',
        value: 'name',
      },
      {
        label: 'Phone',
        value: 'phone',
      },
      {
        label: 'E-mail',
        value: 'email',
      },
      {
        label: 'CNPJ',
        value: 'cnpj',
      },
      {
        label: 'Registration date',
        value: 'createdAt',
      },
    ],
    [],
  );

  return (
    <Box {...rest}>
      <TableFilters
        filterBy={filterBy}
        filterByOptions={filterByOptions}
        onChangeFilterBy={onChangeFilterBy}
        onFilter={onFilter}
        onOrder={onOrder}
        onSort={(sort) =>
          !!onSort &&
          onSort(sort as 'cnpj' | 'name' | 'phone' | 'email' | 'createdAt')
        }
        order={order}
        sortBy={sortBy}
        sortByOptions={sortByOptions}
      />

      <Table colorScheme="blue" mt="4">
        <Thead>
          <Tr>
            <Th>Tenant</Th>
            <Th>Phone</Th>
            <Th>E-mail</Th>
            <Th>Document</Th>
            <Th textAlign="center">Registration date</Th>
            <Th textAlign="center" w="8" />
          </Tr>
        </Thead>

        <Tbody>
          {ventures.map((venture) => (
            <Tr key={venture.id}>
              <Td>
                <Box>
                  <Text fontWeight="bold">{venture.name}</Text>
                </Box>
              </Td>

              <Td>{venture.phone}</Td>

              <Td>{venture.email}</Td>

              <Td>{venture.cnpj}</Td>

              <Td textAlign="center">{venture.formattedDate}</Td>

              <Td textAlign="center">
                <LinkButton
                  px={0}
                  to={{
                    pathname: '/ventures/details',
                    state: {
                      ventureId: venture.id,
                    },
                  }}
                >
                  <Icon as={RiEyeLine} fontSize="16" />
                </LinkButton>
              </Td>
            </Tr>
          ))}
        </Tbody>
      </Table>

      {!!currentPage && !!onPageChange && !!totalPages && totalPages > 1 && (
        <Pagination
          currentPage={currentPage}
          onPageChange={onPageChange}
          totalPages={totalPages}
        />
      )}
    </Box>
  );
};
